import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import ConteudoPagamentos from '../../../components/ConteudoPagamentos'
import Input from '../../../../../../shared/components/Input'
import Form from '../../../../../../shared/components/Form'
import Button from '../../../../../../shared/components/Button'
import { Grid } from '@material-ui/core'
import * as Yup from 'yup'
import Formatter, {
  formatBankSlip,
} from '../../../../../../shared/utils/formatters'
import { InfoText, TextBox } from './styles'
import { isValidValue } from '../../../../../../shared/utils/validates'
import { usePagamentoBoleto } from '../../../../hooks/usePagamentoBoleto'
import LoadingBackdrop from '../../../../../../shared/components/LoadingBackdrop'
import SnackBar from '../../../../../../shared/components/SnackBar'
import { colors } from '../../../../../../shared/styles/colors'

interface IFormConsultaBoletoProps {
  codigoBarras: string
}

const ConsultaBoleto: FunctionComponent = () => {
  const {
    avancar,
    boleto,
    loading,
    consultarDadosBoleto,
    requestError,
    setRequestError,
  } = usePagamentoBoleto()
  const [errorMessage, setErrorMessage] = useState(undefined)
  const [openSnack, setOpenSnack] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const handleSubmit = useCallback(
    async ({ codigoBarras }: IFormConsultaBoletoProps) => {
      setOpenSnack(false)
      setRequestError('')
      setErrorMessage('')
      const sucessoConsulta = await consultarDadosBoleto(codigoBarras)

      if (sucessoConsulta) {
        avancar()
      } else {
        setOpenSnack(true)
      }
    },
    [],
  )

  const validate = (value: string, throwable?: Error) => {
    const valueWithoutSpecialChars = value
      .normalize('NFD')
      .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')

    let error = null
    const isNumber = !isNaN(Number(valueWithoutSpecialChars))

    if (!isValidValue(value)) {
      error = 'Código de barras não informado'
    } else if (isValidValue(error)) {
      error = throwable?.message
    } else if (!isNumber) {
      error = 'Código de barras deve conter apenas números'
    } else if (value.length < 35) {
      error = 'Código de barras deve conter no mínimo 35 dígitos'
    } else if (value.length > 60) {
      error = 'Código de barras deve conter no máximo 60 dígitos'
    }

    if ((value.length >= 35 && value.length <= 60) || !isNumber) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }

    setErrorMessage(error)
  }
  useEffect(() => {
    if (isValidValue(boleto)) {
      setErrorMessage(null)
    } else {
      setErrorMessage(undefined)
    }
  }, [boleto])

  useEffect(() => {
    if (isValidValue(requestError)) {
      setErrorMessage(requestError)
    }
  }, [requestError])

  return (
    <>
      {loading && <LoadingBackdrop open={loading} />}
      <ConteudoPagamentos title={'Pagar Boleto'} titleColor={'#2D3A40'}>
        <TextBox>
          <InfoText>
            Informe o código de barras do boleto que deseja realizar o pagamento
          </InfoText>
        </TextBox>

        <Form
          // enableReinitialize
          onSubmit={values => handleSubmit(values as IFormConsultaBoletoProps)}
          initialValues={{
            codigoBarras: isValidValue(boleto?.codigo_barras)
              ? formatBankSlip(boleto?.codigo_barras)
              : '',
          }}
          validationSchema={() => ({
            codigoBarras: Yup.string()
              .min(35, 'Código de barras deve conter no mínimo 35 dígitos')
              .max(60, 'Código de barras deve conter no máximo 60 dígitos'),
          })}
        >
          {formControl => (
            <>
              <Grid
                container
                spacing={2}
                style={{
                  height: 400,
                }}
              >
                <Grid item sm={6}>
                  <Input
                    name="codigoBarras"
                    placeholder="Código de barras"
                    formControl={formControl}
                    mask={valor => formatBankSlip(valor)}
                    onPaste={event => validate(event.target.value)}
                    onChange={event => validate(event.target.value)}
                    errorMessage={errorMessage}
                    maxLength={60}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Button
                    onClick={formControl.handleSubmit}
                    color={isValid ? colors.green : '#D7DDE0'}
                    type={'submit'}
                    disabled={
                      (errorMessage || errorMessage === undefined) &&
                      !isValidValue(requestError)
                    }
                    style={{
                      color: isValid ? colors.white : '#6D787D',
                    }}
                  >
                    Buscar
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Form>
      </ConteudoPagamentos>
      <SnackBar
        open={openSnack}
        message={requestError}
        setOpen={setOpenSnack}
        severity={'error'}
      />
    </>
  )
}

export default ConsultaBoleto
